/**
 * Utility functions for building payment links consistently
 */

/**
 * Normalizes origin URL to handle trailing slashes and protocol
 */
function normalizeOrigin(origin: string): string {
  if (!origin || typeof origin !== 'string') {
    return '';
  }
  return origin.trim().replace(/\/+$/, '');
}

/**
 * Builds a payment link for an invoice
 * @param origin - The origin URL (e.g., window.location.origin)
 * @param invoiceId - The invoice document ID
 * @returns The complete payment URL
 */
export function buildInvoicePaymentLink(origin: string, invoiceId: string): string {
  const normalizedOrigin = normalizeOrigin(origin);
  const safeInvoiceId = String(invoiceId || '').trim();
  
  if (!normalizedOrigin || !safeInvoiceId) {
    return '';
  }
  
  return `${normalizedOrigin}/payment/${safeInvoiceId}`;
}
